import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function HappiestCustomerSlider() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("https://cauverytours.in/cauverytours-backend/admin/customers.php")
      .then(res => res.json())
      .then(res => {
        if (Array.isArray(res)) {
          setCustomers(res);
        } else {
          setError("Invalid response format from server.");
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Customer fetch error:", err);
        setError("An error occurred while fetching customer photos.");
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading customers...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (customers.length === 0) return <p>No customer photos found.</p>;

  return (
    <section style={{ margin: "50px 0" }} id="gallery">
       <h2 style={{ textAlign: "center", marginBottom: "100px" , marginTop: "100px" , textDecoration: "underline" }}>Happiest Customers</h2>

      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        slidesPerView={1}             // Show 1 customer at a time
        spaceBetween={30}
        loop={true}
        autoplay={{
          delay: 3000,                // 3 sec per customer
          disableOnInteraction: false
        }}
        pagination={{ clickable: true }}
        navigation={true}             // Add next/prev arrows
      >
        {customers.map(customer => (
          <SwiperSlide key={customer.id}>
            <div
              style={{
                textAlign: "center",
                maxWidth: "1200px",
                margin: "0 auto",
              }}
            >
            <img
  src={`https://cauverytours.in/cauverytours-backend/${customer.photo}`}
  alt={customer.name}
  style={{
    width: "1200px",
    height: "500px",
    objectFit: "cover",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    marginBottom: "15px",
  }}
/>

              {customer.name && (
                <p style={{ fontWeight: "bold", marginBottom: "5px" }}>
                  {customer.name}
                </p>
              )}
              {customer.review && (
                <p style={{ fontStyle: "italic", color: "#555" }}>
                  "{customer.review}"
                </p>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
